"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkFFBX5RP6_js = require('./chunk-FFBX5RP6.js');
var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var reactDialog = require('@radix-ui/react-dialog');
var e = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var e__default = /*#__PURE__*/_interopDefaultLegacy(e);

var p=e__default["default"].div`
  @keyframes overlayShow {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  z-index: var(--z-index-200);
  background-color: var(--overlay-100);
  position: fixed;
  inset: 0;
  animation: overlayShow 150ms cubic-bezier(0.16, 1, 0.3, 1);
`,r=e__default["default"].div`
  display: flex;
  gap: var(--spacing-regular);
  justify-content: right;
`,M=e.css`
  width: 416px;
  padding: var(--spacing-x-large);
  ${r} {
    margin-top: var(--spacing-x-large);
  }
`,P=e.css`
  width: 920px;
`,c=e__default["default"](reactDialog.Content)`
  @keyframes contentShow {
    from {
      opacity: 0;
      transform: translate(-50%, -48%) scale(0.96);
    }
    to {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1);
    }
  }

  z-index: var(--z-index-200);
  color: var(--${chunk2VCHSK65_js.b});
  ${chunk2VCHSK65_js.a};
  background-color: var(--background-level-1);
  border-radius: var(--border-radius-small, 6px);
  box-shadow: var(--elevation-400);
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 416px;
  width: var(--content-modal-width);
  max-height: 100vh;
  overflow: auto;
  padding: var(--spacing-x-x-large);
  animation: contentShow 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  gap: var(--spacing-regular);
  flex-direction: column;

  ${r} {
    margin-top: var(--spacing-x-x-large);
  }

  ${({$size:o})=>o==="small"&&M}
  ${({$size:o})=>o==="large"&&P}
`,d=e__default["default"](reactDialog.Title)`
  ${chunkFFBX5RP6_js.a};
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
`,m=e__default["default"](reactDialog.Close)`
  color: var(--${chunk2VCHSK65_js.b});
  position: absolute;
  top: var(--spacing-large);
  right: var(--spacing-large);
  border: none;
  background: none;
  cursor: pointer;
`;var v=({children:o,trigger:i,size:x="regular",modal:u=!0,open:f,onOpenChange:h,onOpenAutoFocus:y,container:b=document.body,...C})=>jsxRuntime.jsxs(reactDialog.Root,{modal:u,open:f,onOpenChange:h,...C,children:[i&&jsxRuntime.jsx(reactDialog.Trigger,{asChild:!0,children:i}),jsxRuntime.jsxs(reactDialog.Portal,{container:b,children:[jsxRuntime.jsx(p,{}),jsxRuntime.jsx(c,{$size:x,onOpenAutoFocus:y,children:o})]})]});v.displayName="Modal";var A={Root:v,Title:d,Description:reactDialog.Description,Close:m,Actions:r};

exports.a = A;
